<div class="p-6">
  @if (loading) {
    <div class="flex justify-center py-12"><div class="animate-spin rounded-full h-7 w-7 border-b-2 border-brand-500"></div></div>
  }

  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (isSystem) {
    <div class="mb-4 p-3 rounded-lg bg-warning-50 border border-warning-200 text-sm text-warning-700 dark:bg-warning-500/10 dark:border-warning-500/20 dark:text-warning-400">
      <span class="font-semibold">Estado del sistema:</span> el código interno no se puede modificar.
    </div>
  }

  @if (!loading) {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-6">

      <!-- Identificación -->
      <section class="space-y-4">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Identificación</h3>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Etiqueta visible <span class="text-error-500">*</span>
          </label>
          <input type="text" formControlName="label"
            (input)="onLabelInput($any($event.target).value)"
            placeholder="Ej. En progreso"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"
            [class.border-error-500]="hasError('label')" [class.border-gray-300]="!hasError('label')"/>
          @if (hasError('label')) { <p class="mt-1.5 text-sm text-error-500">{{ getError('label') }}</p> }
        </div>

        <div>
          <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
            Código interno <span class="text-error-500">*</span>
          </label>
          <input type="text" formControlName="name"
            (input)="onNameInput()"
            placeholder="EN_PROGRESO"
            class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm uppercase font-mono dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 disabled:opacity-60 disabled:cursor-not-allowed"
            [class.border-error-500]="hasError('name')" [class.border-gray-300]="!hasError('name')"/>
          <p class="mt-1 text-xs text-gray-500">Se completa automáticamente desde la etiqueta. Mayúsculas y guiones bajos.</p>
          @if (hasError('name')) { <p class="mt-1.5 text-sm text-error-500">{{ getError('name') }}</p> }
        </div>
      </section>

      <!-- Apariencia -->
      <section class="space-y-4">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Apariencia</h3>

        <div>
          <label class="mb-2 block text-sm font-medium text-gray-700 dark:text-gray-300">Color</label>
          <div class="flex flex-wrap gap-2 mb-3">
            @for (c of COLOR_PRESETS; track c) {
              <button type="button" (click)="setColor(c)"
                class="w-8 h-8 rounded-lg border-2 transition-all hover:scale-110"
                [style.background-color]="c"
                [class.border-gray-900]="form.value.color === c"
                [class.dark:border-white]="form.value.color === c"
                [class.border-transparent]="form.value.color !== c"
                [title]="c">
              </button>
            }
          </div>

          <div class="flex items-center gap-3">
            <div class="relative">
              <input type="color" formControlName="color"
                class="absolute inset-0 w-12 h-12 opacity-0 cursor-pointer"/>
              <div class="w-12 h-12 rounded-lg border-2 border-gray-200 dark:border-gray-700 shadow-sm pointer-events-none"
                [style.background-color]="form.value.color || '#FFC107'"></div>
            </div>
            <input type="text" formControlName="color" placeholder="#FFC107"
              class="flex-1 h-11 rounded-lg border border-gray-300 bg-transparent px-3 text-sm font-mono uppercase dark:border-gray-700 dark:bg-gray-900 dark:text-white/90"/>
          </div>
        </div>

      </section>

      <!-- Comportamiento (switches) -->
      <section class="space-y-3">
        <h3 class="text-xs font-semibold uppercase text-gray-500 tracking-wider">Comportamiento</h3>

        <label class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/40 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/60 transition-colors">
          <div class="relative inline-flex shrink-0 mt-0.5">
            <input type="checkbox" formControlName="isFinal"
              (change)="onIsFinalToggle($any($event.target).checked)"
              class="peer sr-only"/>
            <div class="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer-checked:bg-success-500 transition-colors"></div>
            <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
          </div>
          <div class="flex-1">
            <span class="block text-sm font-medium text-gray-800 dark:text-gray-100">Estado final</span>
            <span class="block text-xs text-gray-500">Las tareas en este estado se consideran completadas/cerradas y no aparecen en pendientes.</span>
          </div>
        </label>

        <label class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/40 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/60 transition-colors">
          <div class="relative inline-flex shrink-0 mt-0.5">
            <input type="checkbox" formControlName="isCompletedTerminal"
              (change)="onTerminalToggle('isCompletedTerminal', $any($event.target).checked)"
              class="peer sr-only"/>
            <div class="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer-checked:bg-success-500 transition-colors"></div>
            <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
          </div>
          <div class="flex-1">
            <span class="block text-sm font-medium text-gray-800 dark:text-gray-100">Terminal de completado</span>
            <span class="block text-xs text-gray-500">
              Destino al completar una tarea (<code class="font-mono">POST /api/tasks/&#123;id&#125;/complete</code>).
              Solo uno por business; activarlo marca automáticamente <strong>Estado final</strong> y desactiva el terminal de cancelación.
            </span>
          </div>
        </label>

        <label class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/40 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/60 transition-colors">
          <div class="relative inline-flex shrink-0 mt-0.5">
            <input type="checkbox" formControlName="isCancelledTerminal"
              (change)="onTerminalToggle('isCancelledTerminal', $any($event.target).checked)"
              class="peer sr-only"/>
            <div class="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer-checked:bg-error-500 transition-colors"></div>
            <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
          </div>
          <div class="flex-1">
            <span class="block text-sm font-medium text-gray-800 dark:text-gray-100">Terminal de cancelación</span>
            <span class="block text-xs text-gray-500">
              Destino al cancelar una tarea (<code class="font-mono">POST /api/tasks/&#123;id&#125;/cancel</code>).
              Solo uno por business; activarlo marca automáticamente <strong>Estado final</strong> y desactiva el terminal de completado.
            </span>
          </div>
        </label>

        <label class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/40 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/60 transition-colors">
          <div class="relative inline-flex shrink-0 mt-0.5">
            <input type="checkbox" formControlName="isDefault" class="peer sr-only"/>
            <div class="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer-checked:bg-brand-500 transition-colors"></div>
            <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
          </div>
          <div class="flex-1">
            <span class="block text-sm font-medium text-gray-800 dark:text-gray-100">Estado por defecto</span>
            <span class="block text-xs text-gray-500">Se asigna automáticamente al crear nuevas tareas. Solo uno puede estar activo a la vez.</span>
          </div>
        </label>

        <label class="flex items-start gap-3 p-3 rounded-lg bg-gray-50 dark:bg-gray-800/40 cursor-pointer hover:bg-gray-100 dark:hover:bg-gray-800/60 transition-colors">
          <div class="relative inline-flex shrink-0 mt-0.5">
            <input type="checkbox" formControlName="isActive" class="peer sr-only"/>
            <div class="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer-checked:bg-brand-500 transition-colors"></div>
            <div class="absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform peer-checked:translate-x-5"></div>
          </div>
          <div class="flex-1">
            <span class="block text-sm font-medium text-gray-800 dark:text-gray-100">Activo</span>
            <span class="block text-xs text-gray-500">Si se desactiva, no aparecerá en los selectores ni en el Kanban.</span>
          </div>
        </label>
      </section>

      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">Cancelar</app-button>
        <app-button variant="primary" type="submit" [disabled]="saving || form.invalid">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </app-button>
      </div>
    </form>
  }
</div>
